import {Injectable} from '@angular/core';
import {ReportProgress} from '../models/report.model';
import {
  REPORT_PROGRESS_COMPLETE_PERCENT, REPORT_PROGRESS_COMPLETE_STAGE,
  REPORT_PROGRESS_DEFAULT_STAGE, REPORT_PROGRESS_EMPTY_COUNT,
  REPORT_PROGRESS_FAILED_STAGE, REPORT_PROGRESS_INITIAL_PERCENT, REPORT_PROGRESS_NUMBER_TYPE,
  REPORT_PROGRESS_STAGE_PREFIX, REPORT_PROGRESS_UNAVAILABLE_AFTER_POLLS,
  REPORT_PROGRESS_UNAVAILABLE_STAGE
} from './report-progress.constants';
import {ReportProgressView} from './report-progress.types';

@Injectable()
export class ReportProgressState {
  private missingProgressPolls = REPORT_PROGRESS_EMPTY_COUNT;

  reset(view: ReportProgressView): void {
    view.showReportProgress = true;
    view.reportProgressPercent = REPORT_PROGRESS_INITIAL_PERCENT;
    view.reportProgressStageKey = this.stageKey(REPORT_PROGRESS_DEFAULT_STAGE);
    this.missingProgressPolls = REPORT_PROGRESS_EMPTY_COUNT;
  }

  apply(view: ReportProgressView, progress: ReportProgress): boolean {
    if (!progress || typeof progress.percent !== REPORT_PROGRESS_NUMBER_TYPE) {
      this.handleMissingProgress(view);
      return false;
    }
    this.missingProgressPolls = REPORT_PROGRESS_EMPTY_COUNT;
    view.reportProgressPercent = progress.percent;
    view.reportProgressStageKey = this.stageKey(progress.stage);
    return progress.completed || progress.failed;
  }

  markUnavailable(view: ReportProgressView): void {
    view.reportProgressStageKey = this.stageKey(REPORT_PROGRESS_UNAVAILABLE_STAGE);
  }

  complete(view: ReportProgressView): void {
    view.reportProgressPercent = REPORT_PROGRESS_COMPLETE_PERCENT;
    view.reportProgressStageKey = this.stageKey(REPORT_PROGRESS_COMPLETE_STAGE);
  }

  fail(view: ReportProgressView): void {
    view.reportProgressStageKey = this.stageKey(REPORT_PROGRESS_FAILED_STAGE);
  }

  private handleMissingProgress(view: ReportProgressView): void {
    this.missingProgressPolls++;
    if (this.missingProgressPolls >= REPORT_PROGRESS_UNAVAILABLE_AFTER_POLLS) {
      this.markUnavailable(view);
    }
  }

  private stageKey(stage: string): string {
    return REPORT_PROGRESS_STAGE_PREFIX + stage;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-progress.state.ts